import {Component} from '@angular/core';

@Component({
  templateUrl: './update-refrigerator-serial-number-dialog.component.html'
})
export class UpdateRefrigeratorSerialNumberDialogComponent {
  constructor() {
  }
}
